export const translationTypes = ["TL","OSI", "TI", "VI", "DT", "DRST"];